/* eslint-disable */
import React, { useState } from "react";
import {
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  FormHelperText,
  IconButton,
  InputAdornment,
  Alert,
  Snackbar,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Link } from "react-router-dom";

// import helper urls
import * as url from "../../helpers/urlHelper";
import {postData} from "../../utils/Gateway";

import { ecosystemSlug } from "../../config/config";

const Register = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    role: "",
    termsAccepted: false,
    ecosystemSlug: ecosystemSlug, // Add ecosystem slug to form data
  });

  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const [alert, setAlert] = useState({ open: false, message: "", severity: "" }); // State for Material-UI Alert

  const handleCloseAlert = () => {
    setAlert({ ...alert, open: false });
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };


    // Function to handle sign-up API call
  const signUpHandler = async (payload) => {
    try {
      const requestURL =
        url.API_BASE_URL + url.API_REGISTER + `?ecosystemslug=${ecosystemSlug}`;

      console.log("Request URL:", requestURL);
      console.log("Payload:", payload);

      const response = await postData(requestURL, payload);

      if (response.status === true) {
        console.log("Registration successful:", response.data);
        setAlert({
          open: true,
          message: "Registration successful!",
          severity: "success",
        });
        setFormData({
          name: "",
          email: "",
          password: "",
          role: "",
          termsAccepted: false,
          ecosystemSlug: ecosystemSlug,
        }); // Clear form data
      } else {
        console.error("Registration failed:", response.message);
        setAlert({
          open: true,
          message: `Registration failed: ${response.message}`,
          severity: "error",
        });
      }
    } catch (error) {
      console.error(
        "Registration failed:",
        error.response?.data || error.message
      );
      setAlert({
        open: true,
        message: "An error occurred. Please try again.",
        severity: "error",
      });
    }
  };

    // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!formData.name) newErrors.name = "Name is required.";
    if (!formData.email) {
      newErrors.email = "Email is required.";
    } else if (!validateEmail(formData.email)) {
      newErrors.email = "Invalid email format.";
    }
    if (!formData.password) newErrors.password = "Password is required.";
    if (!formData.role) newErrors.role = "Role is required.";
    if (!formData.termsAccepted)
      newErrors.termsAccepted = "You must accept the terms and conditions.";

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      const payload = {
        name: formData.name,
        email: formData.email,
        password: formData.password,
        role: formData.role,
      };
      signUpHandler(payload); // Call the API handler
    }
  };

  return (
    <div
      className="container d-flex justify-content-center align-items-center"
      style={{ minHeight: "100vh" }}
    >
      <div className="card p-4" style={{ width: "30rem" }}>
        <h2 className="text-center mb-4">Register</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <TextField
              fullWidth
              label="Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              error={!!errors.name}
              helperText={errors.name}
            />
          </div>
          <div className="mb-3">
            <TextField
              fullWidth
              label="Email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              error={!!errors.email}
              helperText={errors.email}
            />
          </div>
          <div className="mb-3">
            <TextField
              fullWidth
              label="Password"
              name="password"
              type={showPassword ? "text" : "password"} // Toggle password visibility
              value={formData.password}
              onChange={handleChange}
              error={!!errors.password}
              helperText={errors.password}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div className="mb-3">
            <FormControl fullWidth error={!!errors.role}>
              <InputLabel>Role</InputLabel>
              <Select
                name="role"
                value={formData.role}
                onChange={handleChange}
              >
                <MenuItem value="">Select Role</MenuItem>
                <MenuItem value="doctor">Doctor</MenuItem>
                <MenuItem value="patient">Patient</MenuItem>
                <MenuItem value="user">User</MenuItem>
              </Select>
              {errors.role && <FormHelperText>{errors.role}</FormHelperText>}
            </FormControl>
          </div>
          <div className="mb-3">
            <Checkbox
              name="termsAccepted"
              checked={formData.termsAccepted}
              onChange={handleChange}
            />
            <label>I accept the terms and conditions</label>
            {errors.termsAccepted && (
              <p style={{ color: "red", fontSize: "0.875rem" }}>
                {errors.termsAccepted}
              </p>
            )}
          </div>
          <div className="d-grid gap-2">
            <Button
              variant="contained"
              color="primary"
              type="submit"
              style={{ marginBottom: "10px" }}
            >
              Register
            </Button>
            <div className="text-center mt-3">
              <Link to="/login" style={{ textDecoration: "none", color: "blue" }}>
                Already have an account? Login here
              </Link>
            </div>
          </div>
        </form>
      </div>
      <Snackbar
        open={alert.open}
        autoHideDuration={6000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseAlert}
          severity={alert.severity}
          sx={{ width: "100%" }}
        >
          {alert.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Register;
